import { mobileBtn, mainMenu, mainMenuItems } from '../base';
